import { createThemeCompiler } from '../../../utils';

export const progressIndicatorThemeCompiler = createThemeCompiler(({ palette }) => ({
    progressIndicator: {
        colors: {
            determinate: {
                backgroundColor: palette.themeLighterAlt,
                progressIndicatorColor: palette.themePrimary
            },
            Indeterminate: {
                backgroundColor: palette.themeLighterAlt,
                progressIndicatorColor: `linear-gradient(to right, ${palette.themeLighterAlt} 0%, ${palette.themePrimary} 50%, ${palette.themeLighterAlt} 100%)`
            }
        },
        composites: {}
    }
}));
